import React from 'react';
import coolhot from '../../../assets/svg/coolhot.svg';
import smart from '../../../assets/svg/smartenergy.svg';
import star from '../../../assets/svg/star.svg';

import { useScreenSize } from '../../../hooks/useScreenSize';

const Values: React.FC = () => {
  const { isMobile, isTablet } = useScreenSize();
  return (
    <section className="slide flex-colomn gap-2">
      <div className={`flex-colomn `}>
        <h2>
          <span className="tertiary-color ">Waar </span>wij voor staan.
        </h2>
        <p className="slide-text">
          Onze missie? Je elke dag laten genieten van een <span className="bold">betrouwbaar</span>,{' '}
          <span className="bold">comfortabel</span> en <span className="bold">slim</span> geregeld{' '}
          <span className="bold">binnenklimaat.</span>
        </p>
      </div>

      <div className={`${isTablet ? 'flex-colomn' : 'flex-row'} space-between w-100 gap-2`}>
        <div className={`${isMobile ? 'flex-colomn' : 'flex-row'} gap-2`}>
          <div className="flex-row-align gap-2">
            <img className="icon" src={coolhot} alt="phone icon" />
            <p className="light">Koel & comfortabel leven</p>
          </div>
          <div className="flex-row-align gap-2">
            <img className="icon" src={star} alt="phone icon" />
            <p className="light">Betrouwbaar</p>
          </div>
          <div className="flex-row-align gap-2">
            <img className="icon" src={smart} alt="phone icon" />
            <p className="light">Slimme energie</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Values;
